import { gql } from '@apollo/client';

export const FEED_FRAME_GQL = gql`
  query FeedFramePage_frame($id: uuid!) {
    feed_frame_by_pk(id: $id) {
      id
      algorithm_version
      created_at
      deleted_at
      duration
      started_at
      ended_at
      feed_frame_truths(where: { deleted_at: { _is_null: true } }, order_by: { created_at: desc }) {
        truth_mass_in_grams
      }
      feed_frame_analyses(order_by: { created_at: desc }) {
        id
        algorithm_version
        created_at
        latest_estimated_mass_moved_in_grams
        mass_moved_in_grams
        extra_data
        feed_frame_corrected_analyses(order_by: { created_at: desc }) {
          id
          created_at
          deleted_at
          corrected_mass_moved_in_grams
          feed_line_coefficients {
            id
            coefficients
            started_at
            ended_at
            live_ended_at
            is_published
            created_at
            deleted_at
          }
        }
      }
      device {
        id
        hw_version
        serial
        algorithm_version
      }
      feed_line {
        name
        farm {
          name
        }
        bin_set {
          bins {
            name
          }
        }
      }
      feed_frame_notes(where: { deleted_at: { _is_null: true } }, order_by: { created_at: desc }) {
        id
        note
        created_at
        feed_frame_category {
          id
          name
          description
        }
        user {
          id
          name
          email
        }
      }
    }
  }
`;
export const GetFeedFrameCategoriesQuery = gql`
  query GetFeedFrameCategories {
    feed_frame_category(where: { deleted_at: { _is_null: true } }, order_by: { name: asc }) {
      id
      name
      description
    }
  }
`;

export const DeleteFeedFrameMutation = gql`
  mutation DeleteFeedFrame($feedFrameId: uuid!, $deletedAt: bigint!) {
    update_feed_frame_by_pk(pk_columns: { id: $feedFrameId }, _set: { deleted_at: $deletedAt }) {
      id
      deleted_at
    }
  }
`;

export const UndeleteFeedFrameMutation = gql`
  mutation UndeleteFeedFrame($feedFrameId: uuid!) {
    update_feed_frame_by_pk(pk_columns: { id: $feedFrameId }, _set: { deleted_at: null }) {
      id
      deleted_at
    }
  }
`;

export const CreateFeedFrameNoteMutation = gql`
  mutation CreateFeedFrameNote($object: feed_frame_note_insert_input!) {
    insert_feed_frame_note_one(object: $object) {
      id
      feed_frame_id
      feed_frame_category_id
      note
      created_at
    }
  }
`;
